import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import RecommendRanking from '../../parts/RecommendRanking';

const styles = () => ({
  root: {
    width: '80px',
    marginRight: '12px',
    display: 'flex',
    alignItems: 'center',
  },
});

const Level = ({ classes, item }) => {
  if (!item.recommend_rank) {
    return <div className={classes.root} />;
  }

  return (
    <div className={classes.root}>
      <RecommendRanking recommendRank={item.recommend_rank} />
    </div>
  );
};

Level.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.shape({
    recommend_rank: PropTypes.number,
  }).isRequired,
};

export default withStyles(styles)(Level);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/cols/Level.jsx